import noop from 'lodash/fp/noop';
import size from 'lodash/fp/size';

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { hotkeys } from 'react-keyboard-shortcuts';
import TableSearch from '@rio-cloud/rio-uikit/lib/es/TableSearch';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';
import DatePicker from '@rio-cloud/rio-uikit/lib/es/DatePicker';
import ButtonDropdown from '@rio-cloud/rio-uikit/lib/es/ButtonDropdown';
import uid from '~/features/base/utils/uid';
import { DeviceListSelectionDialog } from '~/features/devices/components/DeviceListSelectionDialog';
import CreateLogRequestInBulkDialog from '~/features/devices/components/dialogs/CreateLogRequestInBulkDialog';
import { CM4 } from '~/features/devices/constants/deviceTypes';
import DownloadLogRequestsInBulkDialog
    from '~/features/devices/components/dialogs/DownloadLogRequestBulk/DownloadLogRequestsInBulkDialog';
import DevicesFiltersDialog from '~/features/devices/components/dialogs/DevicesFiltersDialog';
import { env } from '~/env';

export class DeviceListToolbar extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            showDevicesSelectionDialog: false,
            showLogRequestsInBulkDialog: false,
            showDownloadLogRequestsInBulkDialog: false,
            showFiltersDialog: false,
        };
    }
    onSearchValueChange = (prefixValue) => {
        this.props.onSearchValueChange(prefixValue);
    };

    onShowFilterDialog = () => {
        this.setState({ showFiltersDialog: true });
    };

    onHideFiltersDialog = () => {
        this.setState({ showFiltersDialog: false });
    };

    onLastCheckForUpdateChange = (value) => {
        this.props.onLastCheckForUpdateChange(value);
    };

    onShowControlDeviceEditor = () => {
        this.props.onShowControlDeviceEditor();
    };

    onShowColumnSettings = () => {
        this.props.onShowColumnSettings();
    };

    // eslint-disable-next-line camelcase
    hot_keys = {
        'alt+f': {
            priority: 1,
            handler: (event) => this.props.onShowFilterDialog(),
        },
    };

    onClearFiltersClicked = () => {
        this.props.clearFilter();
    };

    render() {
        const { children, defaultedQuery } = this.props;
        const filterDialogButton = this.renderFilterDialogButton();
        const lastCheckForUpdateAfterDatePicker = this.renderLastCheckForUpdateAfterDatePicker(defaultedQuery);
        const searchField = this.renderSearchField(defaultedQuery);
        const columnSettingsButton = this.renderColumnSettingsButton();
        const exportDropdown = this.renderActionsDropdown();
        return (
            <div className='row device-list-toolbar'>
                <div className='col-4'>
                    <div className='btn-toolbar'>
                        {children}
                    </div>
                </div>
                <div className='col-8'>
                    <div className='btn-toolbar pull-right'>
                        {searchField}
                        {lastCheckForUpdateAfterDatePicker}
                        {filterDialogButton}
                        {exportDropdown}
                        {columnSettingsButton}
                    </div>
                </div>

            </div>
        );
    }

    renderSearchField(defaultedQuery) {
        const { intl } = this.props;
        const searchFieldLabel = intl.formatMessage({ id: 'intl-msg:findSerialOrVin' });
        return <div className='table-toolbar-column width-200'>
            <TableSearch
                value={defaultedQuery.serialNumberPrefix || defaultedQuery.vinPrefix || defaultedQuery.shortVinPrefix}
                onChange={this.onSearchValueChange}
                placeholder={searchFieldLabel}
            />
        </div>;
    }

    renderFilterDialogButton() {
        const searchParams = new URLSearchParams(window.location.search);
        const hasActiveFilters = Array.from(searchParams.keys())
            .filter(key => key !== 'vinPrefix' && key !== 'serialNumberPrefix')
            .some(key => {
                const value = searchParams.get(key);
                return value !== null && value !== '';
            });
        const filterIcon = hasActiveFilters ? 'rioglyph-filter-active' : 'rioglyph-filter';

        return <div className='justify-content-center align-items-center'>
            <div className='text-center display-flex'>

                <OverlayTrigger placement='top' overlay={
                    <Tooltip id='tooltip' className='top-right'>
                        <FormattedMessage id='intl-msg:deviceFilterTooltip'/>
                    </Tooltip>}>
                    <button className='btn btn-default '
                            onClick={this.onShowFilterDialog} role='button'>
                        <span className={`rioglyph ${filterIcon} margin-0`}></span>
                    </button>
                </OverlayTrigger>
                <button type='button' className='btn btn-link margin-right-5' onClick={() => this.onClearFiltersClicked()}>
                    <span className='rioglyph rioglyph-trash margin-right-5' aria-hidden='true'></span>
                    <FormattedMessage
                        id='intl-msg:clearAll'
                        defaultMessage='Clear all'
                    />
                </button>
            </div>
            <DevicesFiltersDialog
                show={this.state.showFiltersDialog}
                onHide={this.onHideFiltersDialog}
            />
        </div>;
    }

    renderLastCheckForUpdateAfterDatePicker(defaultedQuery) {
        return <div className=' table-toolbar-column width-200'>
            <DatePicker
                inputProps={{ placeholder: 'Last seen after' }}
                value={defaultedQuery.lastCheckForUpdateAfter ? moment(
                    parseInt(defaultedQuery.lastCheckForUpdateAfter, 10)) : null}
                onChange={this.onLastCheckForUpdateChange}
            />
        </div>;
    }

    renderColumnSettingsButton() {
        return <div className='table-toolbar-column'>
            <button className='btn btn-default btn-icon-only'
                    onClick={this.onShowColumnSettings} role='button'>
                <span className='rioglyph rioglyph-cog'></span>
            </button>
        </div>;
    }

    onShowDevicesSelectionDialog = () => {
        this.setState({ showDevicesSelectionDialog: true });
    };

    onShowCreateLogRequestInBulkDialog = () => {
        this.setState({ showLogRequestsInBulkDialog: true });
    };

    onHideDevicesSelectionDialog = () => {
        this.setState({ showDevicesSelectionDialog: false });
    };

    onHideCreateLogRequestInBulkDialog = () => {
        this.setState({ showLogRequestsInBulkDialog: false });
    };
    onShowDownloadLogRequestsInBulkDialog = () => {
        this.setState({ showDownloadLogRequestsInBulkDialog: true });
    };

    onHideShowDownloadLogRequestsInBulkDialog = () => {
        this.setState({ showDownloadLogRequestsInBulkDialog: false });
    };
    o;
    renderActionsDropdown() {
        const items = [];

        items.push(
            {
                value: [
                    <span key={uid()} className='rioglyph rioglyph-cards-grid padding-right-5'
                          aria-hidden='true'></span>,
                    <FormattedMessage id='intl-msg:exportCSV'/>,
                ],
                onSelect: () => this.props.onExportDevices('csv'),
            },
        );
        items.push(
            {
                value: [
                    <span key={uid()} className='rioglyph rioglyph-cards-list padding-right-5'
                          aria-hidden='true'></span>,
                    <FormattedMessage id='intl-msg:exportSerials'/>,
                ],
                onSelect: () => this.props.onExportDevices('serials'),
            },
        );
        const createLogRequestInBulkAction = <div style={{
            pointerEvents: 'auto',
        }}>
            <span key={uid()} className='rioglyph rioglyph-book padding-right-5'
                  aria-hidden='true'></span>
            <FormattedMessage id='intl-msg:createLogRequestInBulk'/></div>;

        const createDownloadLogRequestInBulkAction = <div style={{
            pointerEvents: 'auto',
        }}>
            <span key={uid()} className='rioglyph rioglyph-cloud-download padding-right-5'
                  aria-hidden='true'></span>
            <FormattedMessage id='intl-msg:downloadLogRequestInBulk'/></div>;

        items.push(
            {
                value: this.props.deviceTypeSelected !== CM4 ? (<OverlayTrigger placement='left' overlay={
                    <Tooltip id='tooltip' className='top-right'>
                        <FormattedMessage id='intl-msg:disableBulkLogRequestTooltip'/>
                    </Tooltip>}>
                    {createLogRequestInBulkAction}
                </OverlayTrigger>) : (createLogRequestInBulkAction),
                onSelect: this.onShowCreateLogRequestInBulkDialog,
                disabled: this.props.deviceTypeSelected !== CM4,
            },
        );

        items.push(
            {
                value: this.props.deviceTypeSelected !== CM4 ? (<OverlayTrigger placement='left' overlay={
                    <Tooltip id='tooltip' className='top-right'>
                        <FormattedMessage id='intl-msg:disableBulkLogRequestTooltip'/>
                    </Tooltip>}>
                    {createDownloadLogRequestInBulkAction}
                </OverlayTrigger>) : (createDownloadLogRequestInBulkAction),
                onSelect: this.onShowDownloadLogRequestsInBulkDialog,
                disabled: this.props.deviceTypeSelected !== CM4,
            },
        );
        items.push(
            {
                value: [
                    <span key={uid()} className='rioglyph rioglyph rioglyph-area-out padding-right-5'
                          aria-hidden='true'></span>,
                    <FormattedMessage id='intl-msg:selectDevices'/>,
                ],
                onSelect: this.onShowDevicesSelectionDialog,
                disabled: !this.props.canCreateControlDevices,
            },
        );
        items.push(
            {
                value: [<hr className='margin-0'></hr>],
                disabled: true,
            },
        );
        items.push(
            {
                value: [
                    <span key={uid()} className='rioglyph rioglyph-plus padding-right-5' aria-hidden='true'></span>,
                    <FormattedMessage id='intl-msg:createControlDevice'/>,
                ],
                onSelect: this.onShowControlDeviceEditor,
                disabled: !this.props.canCreateControlDevices,
            },
        );

        return (
            size(items) ? (
                <div className='table-toolbar-column'>
                    <ButtonDropdown
                        id='mySimpleButtonDropdown'
                        title={
                            <span>
                                <FormattedMessage id='intl-msg:moreActions'/>
                        </span>
                        }
                        items={items}
                    />
                    {this.state.showDevicesSelectionDialog && (
                        <DeviceListSelectionDialog
                            onHide={this.onHideDevicesSelectionDialog}
                        />
                    )}
                    {this.state.showLogRequestsInBulkDialog && (
                        <CreateLogRequestInBulkDialog
                            onHide={this.onHideCreateLogRequestInBulkDialog}
                        />
                    )}
                    {this.state.showDownloadLogRequestsInBulkDialog && (
                        <DownloadLogRequestsInBulkDialog
                            onHide={this.onHideShowDownloadLogRequestsInBulkDialog}
                        />
                    )}
                </div>
            ) : null
        );
    }
}

export default injectIntl(hotkeys(DeviceListToolbar));

DeviceListToolbar.defaultProps = {
    // props
    canCreateControlDevices: false,
    defaultedQuery: {},
    // functions
    onShowControlDeviceEditor: noop,
    onShowColumnSettings: noop,
    onLastCheckForUpdateChange: noop,
    onSearchValueChange: noop,
    onShowFilterDialog: noop,
    updateFilter: noop,
    clearFilter: noop,
};

DeviceListToolbar.propTypes = {
    // props
    canCreateControlDevices: PropTypes.bool,
    defaultedQuery: PropTypes.object,
    // functions
    onShowControlDeviceEditor: PropTypes.func,
    onShowColumnSettings: PropTypes.func,
    onLastCheckForUpdateChange: PropTypes.func,
    onSearchValueChange: PropTypes.func,
    onShowFilterDialog: PropTypes.func,
    updateFilter: PropTypes.func,
    clearFilter: PropTypes.func,
};
